import React from 'react';
import './aboutus.css';

const AboutUs = () => {
  return (
    <div className="aboutus-container">


            {/* Floating Particles */}
      <div className="aboutus-particles">
        {[...Array(50)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 15}s`,
              animationDuration: `${15 + Math.random() * 10}s`,
              width: `${2 + Math.random() * 8}px`,
              height: `${2 + Math.random() * 8}px`,
              background: `rgba(212, 175, 55, ${0.1 + Math.random() * 0.2})`,
            }}
          />
        ))}
      </div>

      
      {/* Hero Section with Banner */}
      <div className="aboutus-hero">
        <img 
          src="/f footer.jpg" 
          alt="Elysians Wellness Spa" 
          className="aboutus-hero-image"
        />
        <div className="aboutus-hero-overlay"></div>
        
        <div className="aboutus-hero-content">
          <div className="aboutus-hero-subtitle">A B O U T</div>
          <h1 className="aboutus-hero-title">
            ELYSIANS <span>WELLNESS</span>
          </h1>
          <p className="aboutus-hero-description">
            Your sanctuary for holistic health and rejuvenation. Where ancient wisdom meets modern luxury.
          </p>
        </div>
        
        <div className="aboutus-scroll-indicator">
          <span>Discover More</span>
          <i className="fas fa-chevron-down"></i>
        </div>
      </div>

      {/* Main Content */}
      <div className="aboutus-content">
        {/* Introduction Section */}
        <div className="aboutus-intro">
          <div className="aboutus-intro-content">
            <span className="aboutus-intro-tag">Our Story</span>
            <h2 className="aboutus-intro-title">
              Where <span>Harmony</span> Meets Healing
            </h2>
            <p className="aboutus-intro-text">
              Welcome to ELYSIANS WELLNESS, your sanctuary for holistic health and rejuvenation.  
              We blend ancient wellness traditions with modern comfort to offer personalized treatments 
              for body, mind, and spirit. Our team of experienced practitioners is dedicated to helping 
              you achieve balance, vitality, and total well-being.
            </p>
            
<div className="aboutus-intro-features">

  <div className="aboutus-feature">
    <i className="fas fa-spa">🌿</i>
    <span>Holistic Approach</span>
  </div>

  <div className="aboutus-feature">
    <i className="fas fa-leaf">🍃</i>
    <span>Natural Products</span>
  </div>

  <div className="aboutus-feature">
    <i className="fas fa-heart">➕</i>
    <span>Personalized Care</span>
  </div>

  <div className="aboutus-feature">
    <i className="fas fa-seedling">🌱</i>
    <span>Serene Environment</span>
  </div>

</div>
          </div>
          
          <div className="aboutus-intro-image">
            <img 
              src="/about-us1.jpg" 
              alt="Luxurious spa interior with peaceful ambiance" 
            />
          </div>
        </div>

        {/* Stats Section */}
        <div className="aboutus-stats">
          <div className="aboutus-stat-item">
            <div className="aboutus-stat-number">20+</div>
            <div className="aboutus-stat-label">Years of Excellence</div>
          </div>
          <div className="aboutus-stat-item">
            <div className="aboutus-stat-number">8+</div>
            <div className="aboutus-stat-label">Expert Therapists</div>
          </div>
          <div className="aboutus-stat-item">
            <div className="aboutus-stat-number">9k+</div>
            <div className="aboutus-stat-label">Happy Clients</div>
          </div>
          <div className="aboutus-stat-item">
            <div className="aboutus-stat-number">10+</div>
            <div className="aboutus-stat-label">Wellness Programs</div>
          </div>
        </div>

        {/* Mission & Vision */}
        <div className="aboutus-mission">
          <div className="aboutus-mission-card">
            <div className="aboutus-mission-icon">
                   <img src="/mission.png" alt="Mission" />
            </div>
            <h3 className="aboutus-mission-title">Our Mission</h3>
            <p className="aboutus-mission-text">
              To provide exceptional wellness experiences that restore balance, promote healing, 
              and inspire a healthier way of living. We are committed to:
            </p>
            <ul className="aboutus-mission-list">
              <li><i className="fas fa-check-circle"></i> Holistic healing approaches</li>
              <li><i className="fas fa-check-circle"></i> Sustainable wellness practices</li>
              <li><i className="fas fa-check-circle"></i> Personalized client care</li>
              <li><i className="fas fa-check-circle"></i> Continuous innovation</li>
            </ul>
          </div>

          <div className="aboutus-mission-card">
            <div className="aboutus-mission-icon">
                   <img src="/vision.png" alt="Vision" />
            </div>

            <h3 className="aboutus-mission-title">Our Vision</h3>
            <p className="aboutus-mission-text">
              To become a globally recognized wellness destination where individuals discover 
              their path to optimal health and inner peace through:
            </p>
            <ul className="aboutus-mission-list">
              <li><i className="fas fa-check-circle"></i> World-class facilities</li>
              <li><i className="fas fa-check-circle"></i> Expert practitioner team</li>
              <li><i className="fas fa-check-circle"></i> Innovative treatments</li>
              <li><i className="fas fa-check-circle"></i> Holistic wellness education</li>
            </ul>
          </div>
        </div>

        {/* Core Values */}
        <div className="aboutus-values">
          <h2 className="aboutus-section-title">Our Core Values</h2>
          <p className="aboutus-section-subtitle">
            The principles that guide every interaction and treatment at ELYSIANS WELLNESS
          </p>
          
          <div className="aboutus-values-grid">
            <div className="aboutus-value-item">
              <div className="aboutus-value-icon">
                <img src="/compassion1.png" alt="compassion" />
              </div>
              <h3 className="aboutus-value-title">Compassion</h3>
              <p className="aboutus-value-description">
                We treat every client with genuine care, empathy, and understanding, 
                creating a safe space for healing.
              </p>
            </div>

            <div className="aboutus-value-item">
              <div className="aboutus-value-icon">
                <img src="/wisdom1.png" alt="wisdom" />
              </div>
              <h3 className="aboutus-value-title">Wisdom</h3>
              <p className="aboutus-value-description">
                We combine ancient healing traditions with modern scientific research 
                for optimal results.
              </p>
            </div>

            <div className="aboutus-value-item">
              <div className="aboutus-value-icon">
          
                   <img src="/intergrity1.png" alt="intergrity" />
            
              </div>
              <h3 className="aboutus-value-title">Integrity</h3>
              <p className="aboutus-value-description">
                We maintain the highest standards of professionalism, honesty, 
                and ethical practices.
              </p>
            </div>
          </div>
        </div>

        {/* Team Section */}
        <div className="aboutus-team">
          <h2 className="aboutus-section-title">Meet Our Experts</h2>
          <p className="aboutus-section-subtitle">
            Dedicated practitioners committed to your wellness journey
          </p>

          <div className="aboutus-team-grid">
            <div className="aboutus-team-member">
              <div className="aboutus-member-image">
                <img src="/dr-dissanayake.png" alt="dr-dissanayake.png" />

              </div>
              <div className="aboutus-member-info">
                <h3 className="aboutus-member-name">Dr. Disanayake</h3>
                <p className="aboutus-member-role">Chief Ayurvedic Practitioner</p>
                <p className="aboutus-member-bio">
                  25+ years experience in  Ayurvedic medicine and therapeutic massage.
                </p>
              </div>
            </div>

            <div className="aboutus-team-member">
              <div className="aboutus-member-image">
                <img src="/dr-srimal.png" alt="dr-srimal.png" />

              </div>
              <div className="aboutus-member-info">
                <h3 className="aboutus-member-name">Dr. Srimal Madushanka</h3>
                <p className="aboutus-member-role">Senior Ayurvedic Practitioner</p>
                <p className="aboutus-member-bio">
                  Expert in traditional Ayurvedic medicine, therapeutic massage and wellness coaching
                </p>
              </div>
            </div>

            <div className="aboutus-team-member">
              <div className="aboutus-member-image">
                <img src="/female1.png" alt="Priya Sharma" />

              </div>
              <div className="aboutus-member-info">
                <h3 className="aboutus-member-name">Sachini Aththanayake</h3>
                <p className="aboutus-member-role">Lead Wellness Coach</p>
                <p className="aboutus-member-bio">
                  Certified Wellness Coach, specialization in therapeutic massage
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonials
        <div className="aboutus-testimonials">
          <h2 className="aboutus-section-title">Client Stories</h2>
          <p className="aboutus-section-subtitle">
            Hear what our clients say about their wellness journey with us
          </p>

          <div className="aboutus-testimonials-slider">
            <div className="aboutus-testimonial">
              <p className="aboutus-testimonial-content">
                "ELYSIANS WELLNESS transformed my life. Their holistic approach to wellness 
                helped me find balance and peace I never thought possible. The team is 
                incredibly knowledgeable and caring."
              </p>
              <div className="aboutus-testimonial-author">
                <div className="aboutus-author-image">
                  <img src="/client1.jpg" alt="Emily Rodriguez" />
                </div>
                <div className="aboutus-author-info">
                  <h4>Emily Rodriguez</h4>
                  <p>Wellness Program Graduate</p>
                </div>
                <div className="aboutus-rating">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
              </div>
            </div>

            <div className="aboutus-testimonial">
              <p className="aboutus-testimonial-content">
                "The personalized attention and expert guidance I received at ELYSIANS 
                WELLNESS exceeded all my expectations. It's not just a spa, it's a 
                sanctuary for true healing."
              </p>
              <div className="aboutus-testimonial-author">
                <div className="aboutus-author-image">
                  <img src="/client2.jpg" alt="David Kim" />
                </div>
                <div className="aboutus-author-info">
                  <h4>David Kim</h4>
                  <p>Regular Client</p>
                </div>
                <div className="aboutus-rating">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* CTA Section */}
        <div className="aboutus-cta">
          <h2 className="aboutus-cta-title">Begin Your Wellness Journey</h2>
          <p className="aboutus-cta-text">
            Experience the transformative power of holistic healing at ELYSIANS WELLNESS. 
            Let us guide you on your path to optimal health and inner peace.
          </p>
          <a href="/booking" className="aboutus-cta-button">
            Schedule Your Visit
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;